import qs from "query-string";
import { Platform, CommonRuntime } from "utils/runtime";

export enum CTR_ACTION {
	show = "show",
	click = "click",
}
const ctrTrackUrl = "https://ctrlitb.rightinthebox.com/ctr_tracking.php";
/*
action ( show or click)
area（recommend_goods）
client (m:jupiter , pc:vela, app: ios or android)
post (从1开始编号，以英文逗号分隔)
pids (商品id, 从1开始编号，以英文逗号分隔， action为show时使用)
cpid (点击的商品id, action 为click时使用)
mp (tights)
*/

const getClient = (runtime: CommonRuntime) => {
	const { platform, isInApp, cookies } = runtime;
	if (isInApp) {
		const ciClient = cookies["ci-client"];
		return ciClient.match(/android/gi) ? "android" : "ios";
	} else if (platform === Platform.WEB) {
		return "vela";
	} else if (platform === Platform.MWEB) {
		return "jupiter";
	}
	return platform;
};
export interface SetLitbCtrTrackOnActionReq {
	cpid: string;
	pos: string;
}
export interface SetLitbCtrTrackOnShowReq {
	pids: string;
	pos: string;
}

/**
 * 商品模块ctr 追踪使用https://www.tapd.cn/20404221/markdown_wikis/show/#1120404221001016487
 * @param props TrackLitbCtrReq
 * @param options
 * @returns
 */
export const SetLitbCtrTrackByType = (action: CTR_ACTION) => {
	let url = ctrTrackUrl;

	return function LitbCtrTrack<T>(params: T, runtime: CommonRuntime) {
		params = {
			...params,
			area: "recommend_goods",
			action,
			client: getClient(runtime),
			mp: "tights",
			language: runtime?.languageCode,
			country: runtime?.countryCode3,
			currency: runtime?.currency,
		};
		// console.log("埋点上报传参数据", params);
		url = `${url}?${qs.stringify(params)}`;
		if (!runtime?.isUat) {
			fetch(url, { mode: "no-cors" }).catch((error) => {
				console.log("ctr error", error);
			});
		}
	};
};
export const SetLitbCtrTrackOnAction = async (
	params: SetLitbCtrTrackOnActionReq,
	runtime: CommonRuntime,
) => {
	SetLitbCtrTrackByType(CTR_ACTION.click)(params, runtime);
};
export const SetLitbCtrTrackOnShow = async (
	params: SetLitbCtrTrackOnShowReq,
	runtime: CommonRuntime,
) => {
	SetLitbCtrTrackByType(CTR_ACTION.show)(params, runtime);
};
